import { Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { BsModalService, BsModalRef, ModalDirective } from 'ngx-bootstrap/modal';
import { QuickDeligation, recentDelegatee, addRequest, ListAddRequest, status, IntegratedAppDetails } from 'src/app/_services/ApplicationServices/quick-delegation';
import { QuickDeligationService } from 'src/app/_services/ApplicationServices/quick-delegation.service';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api'
import { MenuItem } from 'primeng/api';
import { SelectItem } from 'primeng/api';
import { SelectItemGroup } from 'primeng/api';
import { DatePipe, formatDate } from '@angular/common';
import { SAPID } from 'src/app/_utlity/global-variables';
import { catchError } from 'rxjs/operators';
import { LoginService } from 'src/app/_services/ApplicationServices/login.service';
import { GlobalService } from 'src/app/_services/CommonServices/global.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { HttpResponseBase } from '@angular/common/http';
import { WindowService } from 'src/app/_services/CommonServices/windowservice';

@Component({
    selector: 'app-quick-deligation',
    templateUrl: './quick-deligation.component.html',
    styleUrls: ['./quick-deligation.component.css'],
    providers: [MessageService]
    // providers: [CountryService]
    ,
    standalone: false
})
export class QuickDeligationComponent implements OnInit {

  sucImg = "assets/images/tick.gif";


  //range Calendar
  ranges: any = [{
    value: [new Date(new Date().setDate(new Date().getDate() + 30)), new Date()],
    label: '1 Month'
  }, {
    value: [new Date(), new Date(new Date().setDate(new Date().getDate() + 91))],
    label: '3 Months'
  }, {
    value: [new Date(), new Date(new Date().setDate(new Date().getDate() + 182))],
    label: '6 Months'
  }, {
    value: [new Date(), new Date(new Date().setDate(new Date().getDate() + 365))],
    label: '1 Year'
  }
  ];

  isAllAppCheck: boolean = false;
  recentDelegatee: recentDelegatee[];
  EmpltyDeleg: recentDelegatee[] = [];
  searchText: string = '';
  delegateeSapId: string;
  private errorMessage: string;
  sapid: SAPID;
  public DelegatorChecked: boolean = false;
  DelegatorConsen: boolean;
  delegateRequests: ListAddRequest[] = new Array;
  reqStatusRemarks: string = "";
  DelegationStartDate: string;
  DelegationEndDatetime: string;
  RequesterSAPId: string;
  ActionBy: string;
  touchDate: Date = new Date();
  remarks: string;
  sendDelegateRequest: addRequest[] = [];
  reqSubmitMessage: status[] = [];
  unamePattern = "^[a-z0-9_-]{8,15}$";
  startdate: number;
  enddate: number;
  minDate: Date;
  appRoleAndSubRoles: QuickDeligation[];
  public myDatestring: string;
  myDate: Date;
  myDatestringthritydays: string;
  DateRange: string;
  chkNull = null;
  encValues: string = '';
  url: string;
  encSapId: string = '';
  encAppId: string = '';
  encDelReqID: string = '';
  RemarksConsen: boolean;
  copyreqStatusRemarks: string = "";
  diswarmingQuickDele: boolean;
  errorOndehalfDelegation: string;
  errorOndehalfDelegationMultiError: any;
  @ViewChild('validationTemp') templateRef: TemplateRef<any>;
  @ViewChild('validationDelegatee') templateDelegatee: TemplateRef<any>;
  @ViewChild('validationDate') templateDate: TemplateRef<any>;
  @ViewChild('DelegatorConsen') templateDelegatorConsen: TemplateRef<any>;
  @ViewChild('approvedModal') templateapprovedModal: TemplateRef<any>;
  @ViewChild('alertModal') templateAlertModalModal: TemplateRef<any>;
  @ViewChild('rejectModal') public rejectModal: ModalDirective;
  @ViewChild('alertSuccErrorModal') templateAlertSuccErrorModalModal: TemplateRef<any>;
  @ViewChild('alertSuccErrorModalMultiLine') templateSuccErrorModalMultiLine: TemplateRef<any>;

  displayErrorMessage: string = "";
  FromDate: Date;
  ToDate: number;
  visible1: any;
  constructor(private global: GlobalService, private datePipe: DatePipe, private modalService: BsModalService,
    private messageService: MessageService, private router: Router, private quickDelService: QuickDeligationService,
    private loginService: LoginService, private SpinnerService: NgxSpinnerService, private win: WindowService) {
    this.minDate = new Date();
    this.minDate.setDate(this.minDate.getDate());
    this.myDate = new Date();
    this.myDatestring = this.datePipe.transform(this.myDate, 'dd-MMM-yyyy');
    let thirtyday = (d => new Date(d.setDate(d.getDate() + 30)))(new Date);
    this.myDatestringthritydays = this.datePipe.transform(thirtyday, 'dd-MMM-yyyy');

    this.DateRange = this.myDatestring + ' - ' + this.myDatestringthritydays;

    var date1 = new Date(this.myDatestring);
    var date2 = new Date(this.myDatestringthritydays);



    this.FromDate = new Date();
    this.ToDate = this.FromDate.setMonth(this.FromDate.getMonth() + 1);
    this.rangeDates = [new Date, new Date(this.ToDate)];
    // this.DelegationStartDate = this.datePipe.transform(date1, 'yyyy-MM-dd');
    // this.DelegationEndDatetime = this.datePipe.transform(date2, 'yyyy-MM-dd');
  }
  // Show and Hide Div
  addApps: boolean = false;
  selectApp: boolean = true;
  sidebarVisible: any;
  child61: any;
  rangeDates: any;
  addSpoc() {
    this.addApps = true;
    this.selectApp = false;
  }

  addApps1: boolean = false;
  selectApp1: boolean = true;
  addSpoc1() {
    this.addApps1 = true;
    this.selectApp1 = false;
  }
  // Show and Hide Div End

  brands: string[] = [
    'Pawan Gupta (401267)',
    'Pawan Chobe (4016567)',
    'Pawan Misra (40126567)',
    'Pawan  Singh (26540167)',
    'Deivasigamani Tamilselvam (51897560)',
    'Anupama Parameswaran (40387651)'
  ];

  filteredBrands: any[];

  // CheckBox end 


  // Success Alert Start
  isDivOpen: boolean = false;
  ShowSuccess() {
    if (this.DelegatorChecked == true && this.searchText !== "" && this.delegateRequests.length > 0) {
      this.rejectModal.show();
    } else if (this.DelegatorChecked == false) {
      this.errorOndehalfDelegation = "Provide Delegator Consent.";
      this.visible1 = true;
    } else if (this.searchText === "" && this.delegateRequests.length == 0) {
      this.errorOndehalfDelegation = "Please select Delegatee.";
      this.visible1 = true;
    }
    if (this.delegateRequests.length == 0) {
      this.errorOndehalfDelegation = "Please select any application and it's roles before submit.";
      this.visible1 = true;
    }
  }
  // showSuccess() {
  //   this.messageService.add({ severity: 'success', });
  //   setTimeout(() => {
  //     this.router.navigate(['/quick-deligation']);
  //   }, 100);
  // }
  // Success Alert End


  /* MODAL */
  modalRef: BsModalRef;
  // Alert 
  alertIcon = "assets/images/alert.png";
  alertImg = "assets/images/alert.svg";
  alert(template: TemplateRef<any>) {
    this.isDivOpen = false;
    this.modalRef = this.modalService.show(template,
      Object.assign({}, { class: 'alertM' })
    );
  }

  res: any;
  ActiveAppliactionList: any[];
  today = new Date();
  nowtime = formatDate(this.today, 'hh:mm', 'en-US', '+0530'); //Date.now().toString();
  aftertime = formatDate(this.today, 'hh:mm', 'en-US', '+0535');

  ngOnInit(): void {
    this.SpinnerService.show();
    if (this.global.UserLoggedInSAPID != undefined || this.global.UserLoggedInSAPID != null) {
      this.RequesterSAPId = this.global.UserLoggedInSAPID;
      this.ActionBy = this.global.UserLoggedInSAPID;
      this.ActiveAppliactionList = JSON.parse(localStorage.getItem('services_assigned'));
      this.GetRoleBasedOnAppIdForUser();
      this.getRecentDelegatee();
      
    } else {
      this.ActiveAppliactionList = JSON.parse(localStorage.getItem('services_assigned'));
      this.myFirstOperation();
    }

  }

  myFirstOperation() {
    const result = this.loginService.GetDecryptCodeValue(this.global.getSapId());
    result.subscribe((result) => {
      this.global.UserLoggedInSAPID = result.cipherText;
      this.RequesterSAPId = this.global.UserLoggedInSAPID;
      this.ActionBy = this.global.UserLoggedInSAPID;
      this.GetRoleBasedOnAppIdForUser();
      this.getRecentDelegatee();
    });
  }

  bindRecentDelegatee() {
    this.brands = [];
    for (let i = 0; i < this.recentDelegatee.length; i++) {
      this.brands[i] = this.recentDelegatee[i].EmpName + ' (' + this.recentDelegatee[i].SAPID + ')';
    }
  }

  filterBrands(event): void {
    this.bindRecentDelegatee();
    this.filteredBrands = [];
    for (let i = 0; i < this.brands.length; i++) {
      let brand = this.brands[i];
      if (brand.toString().toLowerCase().indexOf(event.query.toString().toLowerCase()) !== -1) {
        this.filteredBrands.push(brand);
      }
    }
  }


  config = {
    backdrop: true,
    ignoreBackdropClick: true
  };

  openModal(approvedModal: TemplateRef<void>) {
    this.isDivOpen = false;
    this.modalRef = this.modalService.show(approvedModal, this.config);
    document.body.classList.add('modal-open2');
  }

  hideSuccessMsg() {
    document.body.classList.remove('modal-open2');
  }

  removeModal() {
    this.modalService.hide(1);
    document.body.classList.add('modal-open2');
  }

  QuickDesignation() {
    this.quickDelService.GetActiveApplications().subscribe(res => {
      this.ActiveAppliactionList = res;
      localStorage.setItem('services_assigned', JSON.stringify(this.ActiveAppliactionList));
    });
  }

  // Load the data based on App Id  and Login User Sap Id
  GetRoleBasedOnAppIdForUser() {
    var DelegatorId = this.global.UserLoggedInSAPID;
    var roleList: any;
    var subRoleList: any;
    if (this.ActiveAppliactionList?.length > 0) {
      this.ActiveAppliactionList.forEach(element => {
        var payload = {
          AppId: element.appId,
          DelegatorId: DelegatorId
        }
        this.quickDelService.GetAppsDelegationRoleandSubRoles(payload).subscribe(res => {
          roleList = res;
          if (roleList[0].AppId == element.appId) {
            if (roleList[0].CDS_GetRoleAndSubRole?.length > 0)
              element.roleAndSubRole = roleList[0].CDS_GetRoleAndSubRole;
            else
              element.isRoleAndSubRoleAvi = true;

            for (let i = 0; i < roleList?.length; i++) {
              if (roleList[i]["IsAdvDelegated"] == false && element.roleAndSubRole != undefined) {
                element.checkapp = true;
              }
              else {
                element.checkapp = false;
                element["DisplayMsg"] = roleList[i].DisplayMsg;

              }

              for (let j = 0; j < roleList[i].CDS_GetRoleAndSubRole.length; j++) {
                if (roleList[i]["IsAdvDelegated"] == false) {
                  element.isAdvDelegated = roleList[i].IsAdvDelegated;
                  element.displayMsg = roleList[i].DisplayMsg;
                  element.roleAndSubRole[j]["check"] = true;
                }
                else {
                  element.isAdvDelegated = roleList[i].IsAdvDelegated;
                  element.displayMsg = roleList[i].DisplayMsg;
                  element.roleAndSubRole[j]["check"] = false;
                  element.roleAndSubRole[j]["DisplayMsg"] = roleList[i].DisplayMsg;
                  break;
                }
                this.delegateRequests.push({ AppId: roleList[i].CDS_GetRoleAndSubRole[j].AppId, AppRoleID: roleList[i].CDS_GetRoleAndSubRole[j].AppRoleID });
              }
            }
          }

          if (this.delegateRequests.length == this.ActiveAppliactionList?.length)
            this.isAllAppCheck = true;
          this.SpinnerService.hide();
        },
          (error: HttpResponseBase) => {
            element.displayMsg = "There's some connectivity issue with this application. Please try later !";
            element["isConnectivity"] = true;
            return;
          });
      });
    }
  }

  //Get the Select Delegative Dropdown first three 
  getRecentDelegatee() {

    this.quickDelService.fetchRecentDelegatee().subscribe(
      {
        next: data => {
          this.recentDelegatee = data;
          //this.brands[0] = this.recentDelegatee[0].EmpName + ' (' + this.recentDelegatee[0].SAPID + ')';
          //this.searchText = this.brands[0];
          //this.delegateeSapId = this.recentDelegatee[0].SAPID;
          this.SpinnerService.hide();
        },
        error: err => this.errorMessage = err
      }
    )
  }

  // Search the employee 
  FetchEmployeeSuggestion(event) {
    if (this.searchText.length > 4) {
      const sapId = <SAPID>
        {
          ReqSAPID: this.searchText
        }
      this.quickDelService.fetchDelegateeSuggestions(sapId).subscribe(
        {
          next: data => {
            this.recentDelegatee = data;
          },
          error: err => this.errorMessage = err
        });
      this.SelectedBrands();
    }
  }

  SelectedBrands() {
    this.bindRecentDelegatee();
    this.filteredBrands = [];
    for (let i = 0; i < this.brands.length; i++) {
      let brand = this.brands[i];

      this.filteredBrands.push(brand);

    }
  }

  // Select the value from dropdwon
  updateDelegateeId(event) {
    if (event !== "" && this.searchText !== "") {
      this.delegateeSapId = event.value.toString().substring(event.value.toString().length - 9, event.value.toString().length - 1);
    }
    else {
      this.delegateeSapId = "";
    }
  }

  // Check box I agree
  onDelegatorchecked(event) {
    this.DelegatorChecked = event;
    if (this.DelegatorChecked == true) {
      this.DelegatorConsen = false;
    }
    else {
      this.DelegatorConsen = true;
    }
  }

  reloadWindow() {
    setTimeout(() => {
      this.router.navigate(['/approval']);
    }, 100);
  }

  // App name check box 
  updateAppNameOptions(index, event) {
    let ind;
    if (event) {
      for (let obj of this.ActiveAppliactionList) {
        if (obj.appId == index) {
          for (let temp of obj.roleAndSubRole) {
            if (temp.AppId == index) {
              temp["check"] = true;
              this.delegateRequests.push({ AppId: temp.AppId, AppRoleID: temp.AppRoleID });
            }
          }
        }
      }
    }
    else {
      for (let obj of this.ActiveAppliactionList) {

        if (obj.appId == index) {

          for (let temp of obj.roleAndSubRole) {
            if (temp.AppId == index) {
              temp["check"] = false;
              this.isAllAppCheck = false;
              for (var i = 0; i < this.delegateRequests.length; i++) {
                if (this.delegateRequests[i].AppId === obj.appId && this.delegateRequests[i].AppRoleID === temp.AppRoleID) {
                  ind = i;
                }
              }
              this.delegateRequests.splice(ind, 1);
              if (this.delegateRequests.filter(x => x.AppId == temp.AppId && x.AppRoleID == temp.AppRoleID).length != obj.roleAndSubRole.length) {
                obj.checkapp = false;
              }
            }
          }
        }
      }
    }
  }

  //Save method in quick delegation
  postAddDelegateRequest() {
    this.SpinnerService.show();
    this.sendDelegateRequest = [];
    if (this.rangeDates == undefined) {
      this.alert(this.templateDate);
    } else {
      this.DelegationStartDate = this.datePipe.transform(this.rangeDates[0], 'yyyy-MM-dd');
      this.DelegationEndDatetime = this.datePipe.transform(this.rangeDates[1], 'yyyy-MM-dd');
      if (this.DelegationStartDate != null && this.DelegationEndDatetime != null) {
        this.reqStatusRemarks = "";
        if (this.DelegatorChecked == true) {
          if (this.delegateRequests.length > 0) {
            if (this.searchText !== "") {
              if (this.DelegationStartDate !== "") {
                for (let i = 0; i < this.delegateRequests.length; i++) {
                  const addRequest = <addRequest>{
                    AppId: this.delegateRequests[i].AppId,
                    RoleId: this.delegateRequests[i].AppRoleID,
                    RequesterSAPId: this.RequesterSAPId,
                    DelegateeSAPId: this.delegateeSapId,
                    ActionBy: this.ActionBy,
                    touchDate: this.touchDate,
                    DelegationStartDate: this.DelegationStartDate,
                    DelegationEndDatetime: this.DelegationEndDatetime,
                    RequestStatus: "PRM",
                    Remarks: this.remarks,
                    ValidationErrorMsg: 'Y',
                    SubRole: [
                      {
                        SubRoleId: null,
                        SubRoleName: null,
                      }
                    ],
                    DelegatorConsen: this.DelegatorChecked
                  }
                  this.sendDelegateRequest.push(addRequest);
                }
                // this.SpinnerService.show();
                this.quickDelService.addDelegationRequest(this.sendDelegateRequest).subscribe((res) => {
                  this.copyreqStatusRemarks = '';
                  this.reqStatusRemarks = '';
                  this.reqSubmitMessage = [];
                  if (res === null || res === '') {
                    this.reqStatusRemarks = 'There is some Error! Please try Again';
                    this.SpinnerService.hide();
                    // this.showSuccess(1);
                    this.messageService.add({ sticky: true, severity: 'error' });
                    catchError(this.quickDelService.handleError);
                  }
                  else {
                    this.reqSubmitMessage.push(res);
                    //this.reqStatusRemarks = res.StatusRemarks;
                    let delegation = res.StatusRemarks.substring(0, res.StatusRemarks.length - 1);
                    this.reqStatusRemarks = delegation.split(',');

                    this.SpinnerService.hide();
                    if (res.DelReqid != 0) {
                      this.loginService.pullEncryptValue(this.global.UserLoggedInSAPID).subscribe(res => {
                        //  
                        if (res.clearText != "" && this.reqSubmitMessage[0].StatusCode != 2 && this.reqSubmitMessage[0].DelReqid != '0') {
                          this.loginService.isEncrypted = true;
                          //  
                          this.encValues = res.clearText;
                          this.encAppId = "/CmHtkGSJ91DqNC1Wxq0Hg=="; //42  DelReqid
                          this.encDelReqID = (this.reqSubmitMessage[0].EncDelReqid === null || this.reqSubmitMessage[0].EncDelReqid === "") ? this.encValues : this.reqSubmitMessage[0].EncDelReqid;
                          this.url = "https://wf33.myhcl.com/feedbacksystem/FeedBack/FeedBack/?id=" + this.encDelReqID + "&&ApplicationID=" + this.encAppId + "&&EmployeeID=" + this.encValues, "pop", "status=no,height=200,width=600,resizable=no,left=400,top=100,toolbar=no, menubar=no,scrollbars=yes,location=no, directories=no,closable: false";
                          //window.open("https://wf33.myhcl.com/feedbacksystem/FeedBack/FeedBack/?id=" + this.encDelReqID + "&&ApplicationID=" + this.encAppId + "&&EmployeeID=" + this.encValues, "pop", "status=no,height=200,width=600,resizable=no,left=400,top=600,toolbar=no, menubar=no,scrollbars=yes,location=no, directories=no,closable: false").focus();                       
                          //safeWindowOpen(this.url,'_blank');
                           this.win.open(this.url);                     ;
                        }
                      });
                      setTimeout(() => {
                        this.removeModal();
                        this.router.navigate(['/approval']);
                      }, 10000);
                      this.openModal(this.templateapprovedModal);
                    } else {
                      this.errorOndehalfDelegation = '';
                      //this.errorOndehalfDelegation = this.reqStatusRemarks;
                      //this.openModal(this.templateAlertSuccErrorModalModal);
                      let delegation = res.StatusRemarks.substring(0, res.StatusRemarks.length - 1);
                      this.errorOndehalfDelegationMultiError = delegation.split(',');
                      this.openModal(this.templateSuccErrorModalMultiLine);
                    }


                    // setTimeout(() => {
                    //   this.removeModal();
                    //   this.router.navigate(['/approval']);
                    // }, 5000);
                    //this.messageService.add({ sticky: true, severity: 'success' });
                    //this.showSuccess(this.reqSubmitMessage[0].StatusCode);

                  }
                },
                  (error: Response) => {
                    this.errorOndehalfDelegation = "Please try with other options.";
                    //alert('Please try with other options');
                    this.visible1 = true;
                    //this.openModal(this.templateAlertModalModal);
                    this.SpinnerService.hide();
                  });
              }
              else {
                this.alert(this.templateDate);
                this.SpinnerService.hide();
              }
            }
            else {
              this.errorOndehalfDelegation = "Please select Delegatee.";
              this.visible1 = true;
              //this.alert(this.templateDelegatee);
              //this.openModal(this.templateAlertModalModal);
              this.SpinnerService.hide();
            }
          }
          else {
            this.errorOndehalfDelegation = "Please select any application and it's roles before submit.";
            this.visible1 = true;
            //this.openModal(this.templateAlertModalModal);
            //this.alert(this.templateRef);
            this.SpinnerService.hide();
          }

        }
        else {
          this.errorOndehalfDelegation = "Provide Delegator Consent.";
          //this.openModal(this.templateAlertModalModal);
          this.visible1 = true;
          //this.alert(this.templateDelegatorConsen);
          this.SpinnerService.hide();

        }
      } else {
        this.errorOndehalfDelegation = "Please select Duration.";
        this.visible1 = true;
        //this.openModal(this.templateAlertModalModal);
        //this.alert(this.templateDate);
        this.SpinnerService.hide();
      }
    }
  }

  updateDateRange(event) {
    if (event !== "" && event !== null) {
      this.startdate = Number(event[0].getMonth());
      this.startdate = this.startdate + 1;
      this.enddate = Number(event[1].getMonth());
      this.enddate = this.enddate + 1;
      this.DelegationStartDate = event[0].getFullYear() + '-' + String(this.startdate) + '-' + event[0].getDate();
      this.DelegationEndDatetime = event[1].getFullYear() + '-' + String(this.enddate) + '-' + event[1].getDate();
    }
    else {
      this.DelegationStartDate = "";
      this.DelegationEndDatetime = "";
    }
  }

  public onRemarkschecked(remarks: string) {

    if (remarks !== "") {
      this.RemarksConsen = false;
    }
    else {
      this.RemarksConsen = true;
    }

  }

  moveDate() {
    this.DelegationStartDate = this.datePipe.transform(this.rangeDates[0], 'yyyy-MM-dd');
    this.DelegationEndDatetime = this.datePipe.transform(this.rangeDates[1], 'yyyy-MM-dd');
  }

  IsUncheckAllApps(event) {
    this.delegateRequests = [];
    if (!event) {
      for (let obj of this.ActiveAppliactionList) {
        obj["checkapp"] = false;
        for (let temp of obj.roleAndSubRole) {
          temp["check"] = false;
        }
      }
    } else {
      for (let obj of this.ActiveAppliactionList) {
        obj.checkapp = true;
        for (let temp of obj.roleAndSubRole) {
          temp.check = true;
          this.delegateRequests.push({ AppId: temp.AppId, AppRoleID: temp.AppRoleID });
        }
      }
    }
  }

  OnClick() {
    this.visible1 = false;
  }

  PostCancelRequest() {
    this.isDivOpen = false;
  }

}
